import { render, staticRenderFns } from "./NlTabs.vue?vue&type=template&id=10501efa&"
import script from "./NlTabs.vue?vue&type=script&lang=js&"
export * from "./NlTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports